'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.buildFormValidator = buildFormValidator;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var validators = exports.validators = {
    requiredWhen: function requiredWhen(fieldName) {
        var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'This field is required';

        return function onRequiredWhen(value, state) {
            var requiredFieldIsPresent = Boolean(state[fieldName]) === true;
            var valueIsPresent = Boolean(value) === true || value === 0;
            return requiredFieldIsPresent && valueIsPresent === false ? message : null;
        };
    },
    withinYearRange: function withinYearRange(maxValue, minValue, message) {
        return function onWithinYearRangeValidation(value) {
            var currentYear = new Date().getFullYear();
            var notInRange = currentYear - value > maxValue || currentYear - value < minValue;
            return notInRange ? message : null;
        };
    },
    required: function required() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'This field is required';

        return function onRequired(value) {
            var valueIsPresent = Boolean(value) === true || value === 0;
            return valueIsPresent ? null : message;
        };
    },
    pattern: function pattern(_pattern, message) {
        return function onPatternValidation(value) {
            return value && _pattern.test(value) === false ? message : null;
        };
    }
};
function buildFormValidator(schema) {
    return function validate(params) {
        return Object.keys(schema).reduce(function (result, paramName) {
            var validatorFns = schema[paramName];
            if (validatorFns instanceof Array) {
                var error = validatorFns.reduce(function (errorMsg, validatorFn) {
                    return errorMsg || validatorFn(params[paramName], params);
                }, null);
                return error == null ? result : Object.assign({}, result, _defineProperty({}, paramName, error));
            }
            var nestedValidator = buildFormValidator(validatorFns);
            return Object.assign({}, result, _defineProperty({}, paramName, nestedValidator(params[paramName])));
        }, {});
    };
}
//# sourceMappingURL=form-validator.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/utils/form-validator.js